import Banner from "../banner";
import '../../styles/servicios.scss';
import torres from '../../assets/torres.jpg';
import Button from "../button";
import { HashLink as Link } from 'react-router-hash-link';
import SimpleHeader from "../simpleHeader";
import ScrollAnimation from "react-animate-on-scroll";

function Torres(){
  return(
    <div>
      <SimpleHeader />
    <div className='servicio-info'>
    <ScrollAnimation animateIn="fadeInLeft" animateOnce={true}>
      <Banner text='Diseño. Construcción. Montaje.'/>
      <h2>Torres Lavadoras de Gases</h2>
    </ScrollAnimation>
    <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={3}>
      <div className='servicios-detalles'>
        <div className='imagen'>
          <img src={torres} alt=""/>
        </div>
        <div className='detalles'>
          <div className='detalles-box'>
            <h3>Nuestro servicio incluye:</h3>
            <ul>
              <li>- Proyecto y diseño.</li>
              <li>- Lavadores tipo Venturi.</li>
              <li>- Montaje de equipos, accesorios.</li>
              <li>- Asesoramiento técnico.</li>
              <li>- Reparaciones integrales.</li>
              <li>- Instalaciones anticorrosivas.</li>
            </ul>
          </div>
          <Link smooth to='/home/#contacto' >
            <Button text='CONTACTANOS' />
          </Link>
        </div>
      </div>
    </ScrollAnimation>
    </div>
    </div>
    );
}

export default Torres;